export const LOCALES = ["id", "en"] as const;
export type Locale = (typeof LOCALES)[number];

/** Bahasa Indonesia is the product default. */
export const DEFAULT_LOCALE: Locale = "id";
export const LOCALE_COOKIE = "villa_locale";

/** BCP-47 tags used for Intl date/number formatting. */
export const INTL_LOCALE: Record<Locale, string> = { id: "id-ID", en: "en-US" };

/** Display names are intentionally untranslated: each language is shown in its own name. */
export const LOCALE_NAMES: Record<Locale, string> = { id: "Bahasa Indonesia", en: "English" };

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}
